export default __webpack_public_path__ + "static/media/gallery_02.a0e58b53.jpg";